export function isUnauthorized($auth) {

	"ngInject";

	return () => !$auth.isAuthenticated();

}


// WEBPACK FOOTER //
// ./sources/filters/isUnauthorized.js